import base from './base'
import production from './production'
import staging from './staging'
import uat from './uat'
const envConfig = {
  staging: staging,
  uat: uat,
  production: production,
}

const stage = process.env.REACT_APP_STAGE
const config = { ...base, ...envConfig[stage] }
export default config
